import { Fragment } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Form, { TypeDocForm } from 'front-office/components/type-doc/form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { typeDocCrubs } from 'front-office/constants/type-doc-crubs';
import { TypeDoc } from 'shell/models/type-doc';
import { transformTypeDoc } from 'front-office/components/type-doc/utils/transform-type-doc';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

const TypeDocEdit = (): React.ReactElement => {
  const params = useParams();

  const [typeDoc] = useHttpFetch<HttpResponse<TypeDoc>, TypeDocForm>(
    `${__CERTIFICATION_API_URL__}/certificazione/tipi-documento/${params.idDoc}/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformTypeDoc,
    }
  );

  const updateTypeDoc = useHttpClient(
    `${__CERTIFICATION_API_URL__}/certificazione/tipi-documento/${params.idDoc}/${params.id}`,
    {
      options: {
        errorCatching: true,
        method: 'PUT',
        loading: true,
        data: {},
      },
    }
  );

  const navigate = useNavigate();

  const onOk = (form: TypeDocForm | undefined) => {
    (
      updateTypeDoc({
        data: {
          descrizioneTipoDocumento: form?.description || undefined,
          tipoDiritti: form?.typeRights || undefined,
          modalitaRilascio: form?.mode || undefined,
          codiceTemplate: form?.template || undefined,
          gruppoDocumento: form?.groupDoc || undefined,
          flagDocumentoInUso: form?.isUse ? '1' : '0',
          tipoIntestatario: form?.holderType || undefined,
          //flagIscrittiAire: form?.isAire ? '1' : '0',
          key: {
            tipoDocumento: form?.typeDoc || undefined,
            codiceDocumento: form?.code || undefined,
          },
        },
      }) as ResponsePromise<void, void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sportello/tipo-doc');
    });
  };

  const loading = typeDoc.isLoading || typeDoc.pristine || typeDoc.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs items={[...typeDocCrubs, { name: 'Modifica Tipo documento' }]} />
      {loading ? null : (
        <Form
          title="Modifica Tipo documento"
          onOk={onOk}
          isEdit
          initialValues={typeDoc.data as TypeDocForm}
          onCancel={() => {
            navigate('/sportello/tipo-doc');
          }}
        />
      )}
    </Fragment>
  );
};

TypeDocEdit.displayName = 'type document edit page component';

export default TypeDocEdit;
